/***
 *  GAIN - Google Analytics In oNe -
 * ========================================
 * Version 1
 *
 * Sets up tracking for pageviews and outbound(offsite) links
 *
 * Note: you need to put you Analytics ID at the bottom of this script
 */

/**
 * onDOMLoad Javascript Function
 * Author: Ross Illingworth
 * URL: www.techmale.com
 * License: GPL.
 * This takes the work from Dean Edwards,Matthias Miller & John Resig,
 * at http://dean.edwards.name/weblog/2006/06/again/#comment5338 and
 * makes it into a useable function for all browsers.
 */

// SafariTimer: holds the id of the timer for safari browser
window.sFT = false;
//DOMLoadFunctions: Array of functions to run when DOM is loaded
window.onDLFs = [];
// Function to call when onDOMload activates
window.callDLFs = function() {
    // check if we have already been here.
    if (!window.callDLFs.done) {
        //alert("Already setup doOnDOMLoaded");
        window.callDLFs.done = true;
        // Stop safariTimer if Active
        if (window.sFT) {
            clearInterval(window.sFT);
        }
        //Now loop through functions and call them
        var func;
        window.onDLFs.forEach(function(onDLF) {
            if (typeof(func = onDLF) === 'function') {
                func.apply(document);
                TM.log(onDLF.name + ' loaded');
            }
        });
    }
};

// MAIN Function
function onDOMLoad(func) {
    // add your function to the function array
    window.onDLFs.push(func);
    // check if we have already done the setup
    if (!window.onDOMLoad.done) {
        //alert("Already setup doOnDOMLoaded");
        window.onDOMLoad.done = true;
        addLibs();
    }
}

function addLibs() {
    //this will work on Firefox or IE
    if (document.addEventListener) {
        //FOR FIREFOX
        //alert("Using addEventListener");
        document.addEventListener('DOMContentLoaded', window.callDLFs, false);
    } else if (document.all && !window.opera) {
        //FOR IE
        document.write('<script type="text/javascript" id="contentloadtag" defer="defer" src="javascript:void(0);"><\/script>');
        var contentloadtag = document.getElementById('contentloadtag');
        contentloadtag.onreadystatechange = function() {
            if (this.readyState === 'complete') {
                //alert("Using readystate");
                window.callDLFs.apply(document);
            }
        };
    }

    // THIS WORKS on SAFARI
    if (/Safari/i.test(navigator.userAgent)) {
        window.sFT = setInterval(function() {
            if (/loaded|complete/.test(document.readyState)) {
                clearInterval(window.sFT);
                //alert("Using Safari");
                // call target function
                window.callDLFs.apply(document);
            }
        }, 10);
    }

    //and finally if all else fails, use onload
    // first check if anything has been set up previously
    var old = (window.onload) ? window.onload : function() {};

    window.onload = function(e) {
        //alert("Now calling onLoad");
        old(e);
        window.callDLFs();
    };
}

/**
 * This is required to add the forEach method to Arrays,
 * if it is missing from the javascript implementation
 * This version comes directly from the Mozilla foundation
 */
//##############################
if (!Array.prototype.forEach) {
    // console.log("Adding forEach");
    Array.prototype.forEach = function(fun /*, thisp*/ ) {
        var len = this.length;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var thisp = arguments[1];
        for (var i = 0; i < len; i++) {
            if (i in this) {
                fun.call(thisp, this[i], i, this);
            }
        }
    };
}
//##############################
/**
 * Add Filter function if missing
 */
if (!Array.prototype.filter) {
    Array.prototype.filter = function(fun /*, thisp*/ ) {
        var len = this.length;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }
        var res = [],
            thisp = arguments[1];
        for (var i = 0; i < len; i++) {
            if (i in this) {
                var val = this[i]; // in case fun mutates this
                if (fun.call(thisp, val, i, this)) {
                    res.push(val);
                }
            }
        }
        return res;
    };
}
//##############################
/**
 * Repeat a function after a set length of time
 * This allows a function to check if required conditions are met
 * and call itself again after a set period of time
 * @param {Object} time_ms
 * @param {Object} scope [Optional]
 */

Function.prototype.repeat = function(time_ms, scope) {
    var func = this;
    var args = this.arguments || [null];
    var f = function() {
        TM.log('now calling: ' + func);
        func.apply(scope, args);
    };
    TM.log('setting ' + func + ' repeat to ' + time_ms);
    setTimeout(f, time_ms, window);
};

var TM = {
    /**
     * An Predefined Empty function
     */
    empty: function() {},
    /**
     * A basic logging function
     * @param {Object} msg
     */
    log: function(msg) {
        if (TM.debug) {
            if (console) {
                console.log(msg);
            } else {
                window.status = msg;
            }
        }
    },
    debug: false,
    /**
     * Function To load a Script asyncronusly
     * This massively reduces page load times
     * @param {Object} path
     * @param {Object} type
     */
    require: function(path, type) {
        type = type || 'SCRIPT';
        var d = document.createElement(type);
        d.src = path;
        if (!navigator.userAgent.indexOf('Opera Mini')) {
            /* Add browsers other than Opera Mini(not supported) */
            d.async = true;
        }
        /* ADD SCRIPT to document */
        var header = document.getElementsByTagName('HEAD')[0];
        var firstScriptTag = header.getElementsByTagName('script')[0];
        if (typeof firstScriptTag === 'undefined') {
            /* no script exist, add as top */
            header.appendChild(d);
        } else {
            header.insertBefore(d, firstScriptTag);
        }
        TM.log('Added external script library ' + path + ' to document header: ');
        /* log when done loading  */
        d.onload = function() {
            TM.log('script loaded ' + path);
        };
    },
    /**
     * Binds a function to an object and wraps it in a new function
     * suggested by www.alistapart.com/articles/getoutbindingsituations
     * this can easily be extended to allow currying
     * @param {Object} object
     * @param {Object} method
     */
    createBoundWrapper: function(object, method) {
        return function() {
            return method.apply(object, arguments);
        };
    },
    /**
     * Container for Regular Expression Functions
     */
    REGEX: {
        protocol: new RegExp("^[^:]+://"),
        currentHost: new RegExp(document.location.hostname),
        //currentHost: new RegExp("epikone.com")
        //currentHost: new RegExp(/epikone\.com/)
        // Chris Egner 2008.10.21
        download: new RegExp("\.(7z|aac|avi|csv|doc|docx|exe|flv|gif|gz|jpe?g|js|mp(3|4|e?g)|mov|pdf|phps|png|ppt|pptx|rar|sit|tar|torrent|txt|wma|wmv|xls|xlsx|xml|zip)$"),
        /**
         * Generate a FILTER Function
         * Tests that regex against objectProperty equals requiredState
         * @param {Object} regex
         * @param {Object} objectProperty
         * @param {Object} requiredState
         */
        def_RegexTestFilterForObjectProperty: function(regex, objectProperty, requiredState) {
            return function(el) {
                if (!el[objectProperty]) {
                    TM.log("Object " + el + " is missing property " + objectProperty);
                    return false;
                }
                return (regex.test(el[objectProperty]) === requiredState);
            };
        }
    },
    /**
     * Container for DOM functions
     */
    DOM: {
        /**
         * Utility function to convert a collection object to an Array
         * Warning: asyncronus removal of elements will cause array to be incorrect
         * @param {Object} collection to convert
         */
        collectionToArray: function(c) {
            var a = [];
            for (var i = 0, len = c.length; i < len; i++) {
                a[a.length] = c[i];
            }
            return a;
        },
        /**
         * Utility function: get an element collection array
         * @param {Object} tagName
         */
        getElementsArrayByTagName: function(tagName) {
            var collection = document.getElementsByTagName(tagName);
            var arr = TM.DOM.collectionToArray(collection);
            return arr;
        }
    }
};

/*****************************************************************************
 * This is the code that controls the tracking insertion
 * As you can see it is very short and very tight
 * ==============================================
 * This is an example of Functional Programming:
 *   where you use one function to create another,
 *   and then pass that function to a third
 * Functional programming is like writing a recipe compared to writing detailed instructions
 *
 * This style of programming also allows you to dynamically create most of your required functions
 * It means shorter code that is faster to load and easier to understand.
 *
 * Get the complete Functional Programming Libary from TechnicalMagic.com
 ********************************************************************************/
TM.GOOGLE = {
    OUTBOUND: {
        /**
         * The main function to call to insert outbound link tracking
         */
        trackLinks: function() {
            // get all links from the page as an array
            // filter the links so we only have outbound links
            // firstly: only if "http://" is present, as this is required by external links
            // secondly: remove all links with the current hostname in the link, as these are local
            // then loop through the remaining links and make each link trackable
            var allLinks = TM.DOM.getElementsArrayByTagName('a');
            var fullLinks = allLinks.filter(TM.REGEX.def_RegexTestFilterForObjectProperty(TM.REGEX.protocol, 'href', true));
            var outboundLinks = fullLinks.filter(TM.REGEX.def_RegexTestFilterForObjectProperty(TM.REGEX.currentHost, 'href', false));
            outboundLinks.forEach(TM.GOOGLE.OUTBOUND.makeTrackable);
            TM.log(outboundLinks.length + ' links modified ');
        },
        /**
         * Take a link and add tracking code
         * Uses onMouseDown, as it is faster, because it works before the page is changed
         * If we used onclick instead, the page could change before the data is sent
         * @param {Object} el
         * @param {Object} ind
         * @param {Object} arr
         */
        makeTrackable: function(el) {
            var oldFunc = (typeof el.onmousedown === 'function') ? TM.createBoundWrapper(el, el.onclick) : TM.empty;
            el.onmousedown = TM.GOOGLE.OUTBOUND.def_TrackableLinkFunc(oldFunc, el.href);
            //el.style.color = TM.GOOGLE.OUTBOUND.color;
        },
        color: "",
        /**
         * This is an example of dynamically creating a function, ie: Functional Programming
         * We create a function that will send the right info to google when called
         * ## NOTE ## pageTracker must already exist for this to work
         * @param {Object} oldFunc
         * @param {Object} href
         */
        def_TrackableLinkFunc: function(oldFunc, href) {
            return function() {
                // check if analytics/pageTracker exists
                if (window.ga.loaded) {
                    // remove "http://" from link url
                    // call pre-existing onmousedown function
                    href = href.replace(TM.REGEX.protocol, "");
                    //window.pageTracker._trackPageview('/outbound/' + href);
                    var trackers = window.ga.getAll();
                    // log outbound link to google
                    TM.GOOGLE.trakOutbound(trackers, {
                        'hitType': 'event',
                        'eventCategory': 'Outbound Link',
                        'eventAction': 'click',
                        'eventLabel': '/outbound/' + href
                    });
                    oldFunc();
                } else {
                    TM.log('analytics pageTracker is UnAvailable');
                }
            };
        }
    },

    // Chris Egner 2008.10.21
    FILE: {
        trackFiles: function() {
            var allLinks = TM.DOM.getElementsArrayByTagName('a');
            var fileDownloadLinks = allLinks.filter(TM.REGEX.def_RegexTestFilterForObjectProperty(TM.REGEX.download, 'href', true));
            fileDownloadLinks.forEach(TM.GOOGLE.FILE.makeTrackable);
        },
        makeTrackable: function(el) {
            var oldFunc = (typeof el.onmousedown === 'function') ? TM.createBoundWrapper(el, el.onclick) : TM.empty;
            el.onmousedown = TM.GOOGLE.FILE.def_TrackableLinkFunc(oldFunc, el.href);
        },
        def_TrackableLinkFunc: function(oldFunc, href) {
            return function() {
                if (window.ga.loaded) {
                    //window.pageTracker._trackPageview(href);
                    var trackers = window.ga.getAll();
                    TM.GOOGLE.trakOutbound(trackers, {
                        'hitType': 'event',
                        'eventCategory': 'File Link',
                        'eventAction': 'click',
                        'eventLabel': href
                    });
                    oldFunc();
                } else {
                    TM.log("analytics pageTracker is UnAvailable");
                }
            };
        }
    },
    /************************************************************
    Track FILE and OUTBOUND for every tracker in ga analytics collection
    * @param  [array] ga analytics array of trakers
    * @param { Object } analytics hit type object
    * Must be one of 'pageview', 'screenview', 'event', 'transaction',
     'item', 'social', 'exception', 'timing'.
    *************************************************************/
    trakOutbound: function(array, trackobj) {
        var obj = trackobj;
        array.forEach(function(tracker) {
            if (typeof tracker !== 'undefined') {
                tracker.send(obj);
            } else {
                TM.log('No valid tracker object: trakOutbound');
            }
        });
    },
    /**
     * Track this page in Google
     * Also sets up pageTracker,
     * so needed for outBound link tracking
     * @param {Object} UID
     */
    trackPageView: function() {
        if (typeof TM.GOOGLE.googleID === 'undefined') {
            return;
        }
        if (!TM.GOOGLE.isAnalyticsLoaded()) {
            TM.log('trackPageView waiting for _gat');
            TM.GOOGLE.trackPageView.repeat(500);
            return;
        }
        TM.GOOGLE.createTracker();
    },
    createTracker: function() {
        window.pageTracker = window._gat._createTracker(TM.GOOGLE.googleID);
        window.pageTracker._setAllowHash(false);
        window.pageTracker._setDomainName(TM.domainToTrack);
        window.pageTracker._setAllowLinker(true);
        window.pageTracker._initData();
        window.pageTracker._trackPageview();
        TM.log('Tracking Page, UID:' + TM.GOOGLE.googleID);
    },
    multiTrackPageView: function() {
        if (typeof TM.GOOGLE.googleIDArr === 'undefined' ||
            TM.GOOGLE.googleIDArr.length === 0) {
            return;
        }
        if (!TM.GOOGLE.isNewAnalyticsLoaded()) {
            TM.log('multiTrackPageView waiting for ga');
            TM.GOOGLE.multiTrackPageView.repeat(500);
            return;
        }
        TM.GOOGLE.createMultiTracker();
    },
    createMultiTracker: function() {
        TM.GOOGLE.googleIDArr.forEach(TM.GOOGLE.AddTracker);
    },
    AddTracker: function(googleId) {
        /* Creates a default tracker for the property UA-XXXXX-Y */
        /* and uses automatic cookie domain configuration. */
        var uniqeTrackerName = TM.trackerName + googleId;
        window.ga('create', googleId, 'auto', {
            'name': uniqeTrackerName,
            allowLinker: true
        });
        window.ga(function() {
            var tracker = window.ga.getByName(uniqeTrackerName);
            tracker.send('pageview');
        });
        TM.log('Tracking Page, UID:' + googleId);
    },
    /**
     * Load the analytics SCRIPT
     */
    loadAnalytics: function() {
        var gaJsHost = (('https:' === document.location.protocol) ? 'https://ssl.' : '//www.'),
            path = gaJsHost + 'google-analytics.com/analytics.js';
        /* check if analytics.js already loaded */
        if (TM.GOOGLE.isLibLoaded(path)) {
            TM.log('script already loaded ' + path);
        } else {
            TM.require(path);
        }
    },
    /* check if.js file already loaded in doc by matching path to src*/
    isLibLoaded: function(path) {
        var arr = [] || document.querySelectorAll('script[src]');
        var bfound = false;
        arr.forEach(function(item) {
            if (item.src === path) {
                bfound = true;
            }
        });
        return bfound;
    },
    /**
     * Check if Analytics is loaded
     */
    isNewAnalyticsLoaded: function() {
        return (window.ga) ? true : false;
    },
    isAnalyticsLoaded: function() {
        return (window._gat) ? true : false;
    },
    /**
     * Tag Manager loaded
     */
    loadTagManager: {
        addIframe: function() {
            /* Create a new noscript node */
            var noscript = document.createElement('noscript'),
                ifrm = document.createElement('iframe'),
                fc = document.body.firstChild;
            /* init iframe */
            ifrm.src = '//www.googletagmanager.com/ns.html?id=' + TM.GOOGLE.googleTmID;
            ifrm.style = {
                'height': '0',
                'width': '0',
                'display': 'none',
                'visibility': 'hidden'
            };
            /* append to dom */
            noscript.appendChild(ifrm);
            /* insert before fc */
            document.body.insertBefore(noscript, fc);
        },
        initTMScript: function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        }
    }
};

/**
 * ########################################################################
 * Edit the code below to modify
 * ########################################################################
 */

/* Turn on debugging output */
TM.debug = false;
/* Domain Track default name (lagacy) */
TM.domainToTrack = 'mitsloan.mit.edu';
/* Sloan OC google tracker default name */
TM.trackerName = 'sloanTracker';
/* Sets the color of the outbound links */
TM.GOOGLE.OUTBOUND.color = '';
/* Sloan OC google analytics ID UA-825956-2 */
TM.GOOGLE.googleID = 'UA-825956-2';
/* Main MIT.edu site google track ID UA-1592615-30 */
TM.GOOGLE.MITGoogleID = 'UA-1592615-30';
TM.GOOGLE.googleIDArr = [TM.GOOGLE.googleID, TM.GOOGLE.MITGoogleID];
/* load google Tag Manager ID GTM-KT6WQ9 */
TM.GOOGLE.googleTmID = 'GTM-KT6WQ9';
onDOMLoad(TM.GOOGLE.loadAnalytics);
/* start google TagManager tracking */
if (window.location.pathname !== '/fellows/admissions/application-process/') {
    onDOMLoad(TM.GOOGLE.loadTagManager.initTMScript(window, document, 'script', 'dataLayer', TM.GOOGLE.googleTmID));
}
onDOMLoad(TM.GOOGLE.loadTagManager.addIframe);
/* start google Analytics tracking for IDs in googleIDArr */
onDOMLoad(TM.GOOGLE.multiTrackPageView);
onDOMLoad(TM.GOOGLE.OUTBOUND.trackLinks);
onDOMLoad(TM.GOOGLE.FILE.trackFiles);